export interface ProductCardOptions {
  activeClass: string;
  hoverImageEl: string;
  imageEl: string;
  itemEl: string;
}

type Options = Partial<ProductCardOptions>;

export class ProductCard {
  static defaults: ProductCardOptions = {
    activeClass: 'is-active',
    hoverImageEl: '[data-productcard-hover]',
    imageEl: '[data-productcard-image]',
    itemEl: '[data-productcard]',
  };
  options: ProductCardOptions;
  mouseOverHandler: EventListener;
  mouseOutHandler: EventListener;

  constructor(options: Options = {}) {
    this.options = {
      ...ProductCard.defaults,
      ...options,
    };

    this.bind();
  }

  bind() {
    this.mouseOverHandler = this.handleMouseOver.bind(this);
    this.mouseOutHandler = this.handleMouseOut.bind(this);

    document.documentElement.addEventListener(
      'mouseover',
      this.mouseOverHandler,
      true,
    );
    document.documentElement.addEventListener(
      'focus',
      this.mouseOverHandler,
      true,
    );
    document.documentElement.addEventListener(
      'mouseout',
      this.mouseOutHandler,
      true,
    );
    document.documentElement.addEventListener(
      'blur',
      this.mouseOutHandler,
      true,
    );
  }

  handleMouseOver(event: Event) {
    this.toggle(event.target as HTMLElement, true);
  }

  handleMouseOut(event: Event) {
    this.toggle(event.target as HTMLElement, false);
  }

  toggle(element: HTMLElement, state: boolean = true) {
    const match = element.closest(this.options.itemEl);

    if (!match) {
      return;
    }

    this.swapImage(match, state);
    match.classList.toggle(this.options.activeClass, state);
  }

  swapImage(target: Element, state: boolean) {
    const image = target.querySelector(this.options.imageEl);
    const hoverImage = target.querySelector(this.options.hoverImageEl);

    if (!hoverImage || !image) {
      return;
    }

    image.classList.toggle(this.options.activeClass, !state);
    hoverImage.classList.toggle(this.options.activeClass, state);
  }

  destroy() {
    document.documentElement.removeEventListener(
      'mouseover',
      this.mouseOverHandler,
      true,
    );
    document.documentElement.removeEventListener(
      'focus',
      this.mouseOverHandler,
      true,
    );
    document.documentElement.removeEventListener(
      'mouseout',
      this.mouseOutHandler,
      true,
    );
    document.documentElement.removeEventListener(
      'blur',
      this.mouseOutHandler,
      true,
    );
  }
}
